export default {
  auth: {
    forgot_password: 'Passwort vergessen?'
  }
}



// WEBPACK FOOTER //
// ./src/lang/de/links.js